import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8498c7f0")
const _hoisted_1 = { class: "cost_shortcut" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("footer", { class: "p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Imposta rapidamente il prezzo per tutte le fasce orarie.")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      class: "p-formgroup-inline"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FloatLabel, { label: "Lunedì - Venerdì" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              mode: "currency",
              currency: "EUR",
              modelValue: _ctx.lunVen,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.lunVen = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FloatLabel, { label: "Sabato" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              mode: "currency",
              currency: "EUR",
              modelValue: _ctx.saturday,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.saturday = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FloatLabel, { label: "Domenica" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              mode: "currency",
              currency: "EUR",
              modelValue: _ctx.sunday,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.sunday = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Button, {
        type: "submit",
        icon: "pi pi-check",
        label: "Applica"
      })
    ], 32),
    _hoisted_5
  ]))
}